module.exports = __webpack_public_path__ + "img/v3-folder.7d582d54.svg";